import {getTokens, registerRefreshedToken} from "./axiosTokenStoreHandler";
import {
    createArtistRefreshRequestConfig,
    getArtistRefreshTokenEndpoint,
    getStudioRefreshTokenEndpoint,
} from "../api/commonApi";
import {axiosPublic} from "./axiosPublic";
import {store} from "../index";
import {initiateLogoutStudio} from "../store/auth/authActions";

export const getRefreshedArtistToken = async () => {
    const {artistTokens, studioTokens} = getTokens()
    if (!artistTokens?.artistRefreshToken || !studioTokens?.studioToken) {
        console.log('No artist or studio tokens found')
        return {}
    }
    try {
        const {data} = await fetchArtistRefreshToken({
            refreshToken: artistTokens.artistRefreshToken,
            token: studioTokens.studioToken
        })
        registerRefreshedToken('artistToken', data.data)
        return {artistToken: data.data}
    } catch (error) {
        if (error?.response?.status === 401) {
            try {
                const {studioToken} = await fetchStudioRefreshToken()
                if (studioToken) {
                    const {data} = await fetchArtistRefreshToken({
                        refreshToken: artistTokens.artistRefreshToken,
                        token: studioToken
                    })
                    registerRefreshedToken('artistToken', data.data)
                    return {artistToken: data.data}
                } else {
                    console.log('No studio token found')
                    setTimeout(() => store.dispatch(initiateLogoutStudio()), 0)
                    return {}
                }
            } catch (error) {
                return {}
            }
        }
        return {}
    }
}

const fetchArtistRefreshToken = ({refreshToken, token}) => {
    return axiosPublic.get(getArtistRefreshTokenEndpoint(refreshToken), createArtistRefreshRequestConfig(token))
}

const fetchStudioRefreshToken = async () => {
    const {studioTokens} = getTokens()
    if (!studioTokens?.studioRefreshToken) {
        return {}
    }
    try {
        const {data} = await axiosPublic.get(getStudioRefreshTokenEndpoint(studioTokens.studioRefreshToken))
        registerRefreshedToken('studioToken', data.data)
        return {studioToken: data.data}
    } catch (error) {
        return {}
    }
}
